import { render, staticRenderFns } from "./TopLeft.vue?vue&type=template&id=54f1d8b4"
import script from "./TopLeft.vue?vue&type=script&lang=js"
export * from "./TopLeft.vue?vue&type=script&lang=js"
import style0 from "./TopLeft.vue?vue&type=style&index=0&id=54f1d8b4&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports